<template>
    <v-modal title="Reactivate Order" @close="$emit('close')" :scroll="true">
        <div slot="contents">
            <div class="modal-content">
                <v-error-messages
                    :has-frontend-errors="$v.$error"
                    class="stack-l">
                    <li class="list-item" v-if="!$v.reactivation.renewalTime.validDate">The renewal time must be a valid
                        date.
                    </li>
                </v-error-messages>
                <p class="stack-m">Reactivate this order and optionally provide a description and a new renewal
                    time.</p>
                <div class="grid-content">
                    <div class="grid-item grid-item-full">
                        <r-input
                            class="stack-m"
                            label="Description"
                            multiline
                            rows="3"
                            v-model="reactivation.description"/>
                    </div>
                    <div class="grid-item grid-item-full">
                        <v-date-input
                            class="stack-m"
                            label="New Renewal Time"
                            :available-dates='{start: new Date(), end: null}'
                            v-model="reactivation.renewalTime"/>
                    </div>
                </div>
            </div>
            <!--<div class="modal-content">-->
            <!--<v-checkbox-->
            <!--label="Send email to customer"-->
            <!--v-model="sendEmail"-->
            <!--:value="true"-->
            <!--caption="Notify the customer by email that his order was reactivated."-->
            <!--/>-->
            <!--</div>-->
        </div>
        <template slot="actions">
            <r-button type="primary" @click="reactivateOrder">Reactivate</r-button>
        </template>
    </v-modal>
</template>

<script>
    import {
        vCheckbox, vDateInput, vErrorMessages,
    } from '@/components/form';
    import vModal from '@/components/modal/v-modal';
    import moment from 'moment';
    import _ from '@/common/helpers';
    import OrderReactivationModel from '@/common/models/order-reactivation-model';

    export default {
        name: 'reactivate-modal',
        inject: ['reactivate'],
        props: {
            order: Object,
        },
        components: {
            vModal,
            vDateInput,
            vCheckbox,
            vErrorMessages,
        },
        validations: {
            reactivation: {
                renewalTime: {
                    validDate(v) {
                        return _.isBlank(v) ? true : moment(v).isValid();
                    },
                },
            },
        },
        data() {
            return {
                reactivation: new OrderReactivationModel({subscriptionId: this.order.id}),
                sendEmail: false,
            };
        },
        methods: {
            reactivateOrder() {
                this.$v.$touch();
                if (!this.$v.$error) {
                    this.reactivate({data: this.reactivation.getPayload(), sendEmail: this.sendEmail});
                    this.$emit('close');
                }
            },
        },
    };
</script>
